import http from "../index";

// * 用户注册时的短信验证码
export const getSignInCode = (params) => {
	return http.post(`/api/v1/union/unLoginSendSmsCode`, params);
};

// * 用户注册
export const register = (params) => {
	return http.post(`/api/v1/org/admin/register`, params);
};


// * 用户登录
export const login = (params) => {
	return http.post(`/api/v1/union/login`, params);
};

// * 重置密码
export const resetPassword = (params) => {
	return http.post(`/api/v1/union/resetPassword`, params);
};

// * 省厅登录
export const unionLogin = (params) => {
	return http.post(`/api/v1/union/login`, params);
};

// 首页课程列表
export const recommendCourseList = (params,header) => {
	return http.post(`/api/v1/home/recommendCourseList`, params,header);
};

// 点赞
export const courseZan = (params,header) => {
	return http.post(`/api/v1/home/courseZan`, params,header);
};